import { CARE_COST_DISCLAIMER } from '../constants/careCosts.constants';

export const CareCostsFooter = () => (
  <footer>
    <p className="text-sm font-normal leading-relaxed text-muted-foreground">
      {CARE_COST_DISCLAIMER}
    </p>
  </footer>
);
